import {Client} from "@stomp/stompjs";
import {OrderModel} from "../Models/OrderModel";
import {useTranslation} from "react-i18next";

const EDENRED_LOCALES: Record<string, string> = {
    fr: 'fr-FR',
    en: 'en-GB',
    it: 'it-IT',
    es: 'es-ES',
    // Interface Edenred en chinois non garantie : on bascule sur l'anglais.
    zh: 'en-GB',
}

export const useAddEdenred = (panier?: OrderModel, onSuccess?: (token: string, authorizationId: string) => void, onError?: () => void): [() => void] => {
    const {i18n} = useTranslation()

    const addEdenred = () => {
        const body = {
            mid: process.env.REACT_APP_EDENRED_MID,
            order_ref: panier?.reference,
            amount: panier?.totalPriceTTC ? +panier.totalPriceTTC * 100 : 0,
            tstamp: new Date(),
        }
        const uiLocale = EDENRED_LOCALES[i18n.language] ?? EDENRED_LOCALES.fr
        const url = `${process.env.REACT_APP_EDENRED_BASE_URL}/connect/authorize?response_type=code&client_id=${process.env.REACT_APP_EDENRED_CLIENT_ID}&state=${JSON.stringify(body)}&scope=openid%20edg-xp-mealdelivery-api%20offline_access&redirect_uri=${process.env.REACT_APP_EDENRED_REDIRECT_URI}&acr_values=tenant%3Afr-ctrtku&ui_locales=${uiLocale} `
        window.open(url, '_blank')
        waitResponse()
    }

    const waitResponse = () => {
        const client = new Client({
            brokerURL: `${process.env.REACT_APP_SOCKET_URL}/ws-message`,
            reconnectDelay: 5000,
            heartbeatIncoming: 4000,
            heartbeatOutgoing: 4000,
            onConnect: () => {
                client.subscribe('/edenred/response', function (msg) {
                    console.log(msg)
                    if (msg.body) {
                        const jsonBody = JSON.parse(msg.body)
                        if(jsonBody.token) {
                            onSuccess && onSuccess(jsonBody.token, jsonBody.authorizationId)
                        } else {
                            onError && onError()
                        }
                    } else {
                        onError && onError()
                    }
                    void client.deactivate()
                });
            }
        });

        client.activate();
    }

    return [addEdenred]
}
